import { Controller } from "@hotwired/stimulus"
import { readCookie, setCookie } from "../helpers/cookie_helpers"
import { isHTMLElement } from "~/types/types.util"

const NUGGITS_VIEW_COOKIE_NAME = "nuggits_view"

export default class NuggitsViewController extends Controller {
  static targets = ["switch"]

  declare readonly switchTargets: HTMLInputElement[]

  connect() {
    this.#restoreViewPref(NUGGITS_VIEW_COOKIE_NAME)
  }

  saveViewPref(event: InputEvent) {
    const target = event.target
    if (target && isHTMLElement(target)) {
      const viewType = target.dataset.nuggitsViewTypeValue
      setCookie(NUGGITS_VIEW_COOKIE_NAME, viewType)
    }
  }

  #restoreViewPref(id: string) {
    const viewType = readCookie(id) || "grid"
    this.switchTargets.forEach((switchTarget) => {
      switchTarget.checked = switchTarget.dataset.nuggitsViewTypeValue === viewType
    })
  }
}
